import { DialogContent, DialogTitle, Stack } from "@mui/material";
import { productExportWarehouseBusiness } from "api/bussiness/product/product-export-warehouse-bussiness";
import { dateTimeToUTCString } from "commons/ultilities/date/dayjs";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { DynamicFormArray } from "commons/ultilities/dynamic-form/components/dynamic-form-array";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import dayjs from "dayjs";
import { observer } from "mobx-react-lite";
import { IAddProductGoodsIssue } from "mobx-stores/_models/product-inventory/product-goods-issue/product-goods-issue";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useMemo } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { getAddProductGoodsIssueSchema } from "./schema";

export const AddProductGoodsIssue = observer(() => {
  const {
    productInventoryManagement: {
      productGoodsIssueStore: { openNew, getProductGoodsIssue, setProp },
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<IAddProductGoodsIssue>(getAddProductGoodsIssueSchema(), {
    exportDate: dateTimeToUTCString(dayjs()),
    items: [
      {
        productId: "",
        note: "",
        quantity: 0,
      },
    ],
  });

  const saveHandler = useCallback(
    async (data: IAddProductGoodsIssue) => {
      try {
        await productExportWarehouseBusiness.add(data);
        await getProductGoodsIssue();
        setProp("openNew", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [getProductGoodsIssue, setProp]
  );

  const itemsControl = useMemo(() => {
    return getControl("items").children;
  }, [getControl]);

  return (
    <DialogForm
      open={openNew}
      fullWidth
      maxWidth={"sm"}
      onClose={() => setProp("openNew", false)}
      onCancelBtnClicked={() => setProp("openNew", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Thêm xuất kho</DialogTitle>
      <DialogContent>
        <Stack sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
          {itemsControl && itemsControl.length > 0 && (
            <DynamicFormArray
              children={itemsControl}
              controlSpacing={2}
            ></DynamicFormArray>
          )}
        </Stack>
      </DialogContent>
    </DialogForm>
  );
});
